export const CHART_TYPE = {
  EARNINGS: 'earnings',
  SUBS: 'subs',
  CUMULATIVE_ERANINGS: 'cumulativeEarnings',
  CUMULATIVE_SUBS: 'cumulativeSubs'
};
